export enum FormKeys {
    ConnectionType = 'connectionType',
    IpAddress = 'ipAddress',
}
